/** @module csi/image/ImageEditorReset **/
define([
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/view/PluginFactory",
	"csi/view/ToolbarPluginButton",
	"csi/image/ImageEditorPluginMixin"
], function(lang,Action,PluginFactory,ToolbarPluginButton,ImageEditorPluginMixin) {

	return PluginFactory.declare("imagereset", [ToolbarPluginButton, ImageEditorPluginMixin], {
		showLabelWithIcon: true,

		/**
		 * Set the action for Reseting Cropper changes
		 */
		constructor: function() {
			this.defAction = lang.mixin(new Action(), {
				m_id: "ImageEditorReset",
				m_onAction: "resetCropper"
			});
			this.defAction.setMaterialIcon("refresh");
			this.defAction.resolve();
		}
	});
});